import React, { createContext, useCallback, useContext, useState } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

const ToastCtx = createContext(null);

let idCounter = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const remove = useCallback((id) => {
    setToasts((list) => list.filter((t) => t.id !== id));
  }, []);

  const push = useCallback((opts) => {
    const id = ++idCounter;
    const toast = {
      id,
      title: opts.title || '',
      message: opts.message || '',
      variant: opts.variant || 'success', // success | danger | warning | info
      delay: opts.delay || 3500,
    };
    setToasts((list) => [...list, toast]);
    return id;
  }, []);

  const api = {
    success: (message, title = 'Success') => push({ message, title, variant: 'success' }),
    error: (message, title = 'Error') => push({ message, title, variant: 'danger', delay: 5000 }),
    info: (message, title = '') => push({ message, title, variant: 'info' }),
    warning: (message, title = 'Heads up') => push({ message, title, variant: 'warning' }),
  };

  return (
    <ToastCtx.Provider value={api}>
      {children}
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1080 }}>
        {toasts.map((t) => (
          <Toast
            key={t.id}
            onClose={() => remove(t.id)}
            show
            delay={t.delay}
            autohide
            bg={t.variant}
            data-testid="app-toast"
          >
            {t.title && (
              <Toast.Header closeButton>
                <strong className="me-auto">{t.title}</strong>
              </Toast.Header>
            )}
            <Toast.Body className={t.variant === 'warning' ? '' : 'text-white'}>
              {t.message}
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </ToastCtx.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
